import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { CnMenuButton, CnMenuButtonItem, CnMenuButtonGroup, CnButton, CnBadge, CnBalloon, CnMessage, CnDialog, cnQuickDialogForm, CnIcon, } from '@alife/cn-ui';
import $i18n from 'panda-i18n';
import { useMemoizedFn } from 'ahooks';
import classnames from 'classnames';
import { event } from '@ice/stark-data';
import { reportHottag } from '../utils';
import { hottagPrefix, viewNameLengthLimit, customViewsLengthLimit, } from '../const';
function ViewSelector({ viewList = [], viewId = '', onChange, isCurrentViewModified = false, needShowUserGuide = false, onHideUserGuide = () => { }, disabled = false, cacheHabitData = {
    views: [],
    defaultViewId: '',
    needShowUserGuide: false,
}, onHabitDataChange = () => { }, presetDefaultViewId = '', genNewViewDetail = () => {
    return {};
}, defaultViews = [], hideHabitSaveBtn = false, extendSaveViewFormSchema = {}, isOpenViewUpdate = false, }) {
    const selectedView = useMemo(() => {
        const pureList = [];
        viewList.forEach((item) => {
            if (item.children) {
                pureList.push(...item.children);
            }
            else {
                pureList.push(item);
            }
        });
        return (pureList.find((item) => item.value === viewId) || {
            label: $i18n.get({
                id: 'PleaseSelectQueryCriteria',
                dm: '请选择查询条件',
            }),
        });
    }, [viewList, viewId, $i18n]);
    const [visible, setVisible] = React.useState(false);
    const handleSelect = (newViewId) => {
        reportHottag({
            hottag: `${hottagPrefix}.view.selected`,
            name: '选择查询条件',
            c6: newViewId,
        });
        if (newViewId === viewId)
            return;
        onChange(newViewId);
    };
    const handleSetDefaultView = useMemoizedFn(async (newDefaultViewId) => {
        const newHabitData = {
            ...cacheHabitData,
        };
        newHabitData.defaultViewId = newDefaultViewId;
        onHabitDataChange(newHabitData, (res = {}) => {
            if (res.success) {
                CnMessage.success($i18n.get({
                    id: 'DefaultQueryCriteriaSetSuccessfully',
                    dm: '默认查询条件设置成功',
                }));
            }
            else {
                CnMessage.error(res?.error?.message ||
                    $i18n.get({
                        id: 'FailedToSetDefaultQueryCriteria_828388662',
                        dm: '默认查询条件设置失败',
                    }));
            }
        }, {
            action: 'setDefault',
            value: newDefaultViewId,
        });
    });
    const handleDeleteView = useMemoizedFn(async (viewItem = {}) => {
        const { id: needDeleteViewId, label } = viewItem;
        const invoke = async () => {
            const newHabitData = {
                ...cacheHabitData,
            };
            newHabitData.views = newHabitData.views.filter((v) => v.id !== needDeleteViewId);
            if (newHabitData.defaultViewId === needDeleteViewId) {
                newHabitData.defaultViewId = presetDefaultViewId;
            }
            onHabitDataChange(newHabitData, (res = {}) => {
                if (res.success) {
                    CnMessage.success($i18n.get({ id: 'QueryCriteriaDeleted', dm: '查询条件删除成功' }));
                    if (needDeleteViewId === viewId) {
                        onChange(newHabitData.defaultViewId);
                    }
                }
                else {
                    CnMessage.error(res?.error?.message ||
                        $i18n.get({
                            id: 'FailedToDeleteQueryCriteria',
                            dm: '查询条件删除失败',
                        }));
                }
            }, {
                action: 'delete',
                value: needDeleteViewId,
            });
        };
        CnDialog.confirm({
            title: $i18n.get({
                id: 'QueryCriteriaDeletionConfirmation',
                dm: '查询条件删除确认',
            }),
            content: $i18n.get({
                id: 'AreYouSureYouWantTo_1246568526',
                dm: '您确定要删除“{label}”的查询条件吗？',
            }, { label }),
            onOk: invoke,
        });
    });
    const renderViewItem = (viewItem) => {
        const handleDelViewBtnClick = (e) => {
            e.stopPropagation();
            handleDeleteView(viewItem);
        };
        const handleSetDefaultViewBtnClick = (e) => {
            e.stopPropagation();
            handleSetDefaultView(viewItem.id);
        };
        const delBtn = viewItem.type !== 'system' ? (_jsx(CnButton, { className: 'del-btn', size: 'small', text: true, onClick: handleDelViewBtnClick, "data-hottag": `${hottagPrefix}.view.delete`, "data-hottag-name": '\u5220\u9664\u89C6\u56FE', "data-hottag-ext-params": JSON.stringify({
                sampling: 1,
            }), children: $i18n.get({
                id: 'delete',
                dm: '删除',
            }) })) : null;
        const defaultTag = (_jsx(CnButton, { disabled: true, text: true, size: 'small', className: 'default-view-tag', children: $i18n.get({ id: 'DefaultQuery', dm: '默认查询' }) }));
        const setDefaultBtn = (_jsx(CnButton, { className: 'set-default-btn', size: 'small', text: true, onClick: handleSetDefaultViewBtnClick, "data-hottag": `${hottagPrefix}.view.setDefault`, "data-hottag-name": '\u8BBE\u7F6E\u9ED8\u8BA4\u89C6\u56FE', "data-hottag-ext-params": JSON.stringify({
                sampling: 1,
            }), children: $i18n.get({ id: 'SetAsDefaultQuery', dm: '设为默认查询' }) }));
        return (_jsxs(CnMenuButtonItem, { className: classnames({
                'view-item': true,
                'view-item-selected': viewItem.value === viewId,
            }), size: 'medium', value: viewItem.value, onClick: () => {
                handleSelect(viewItem.value);
            }, children: [_jsx("span", { className: 'align-left', children: viewItem.label }), _jsxs("div", { className: 'align-right', children: [delBtn, viewItem.id === cacheHabitData.defaultViewId
                            ? defaultTag
                            : setDefaultBtn] })] }, viewItem.value));
    };
    let { label } = selectedView;
    if (isCurrentViewModified) {
        label = (_jsx(CnBadge, { className: 'view-change-badge', dot: true, children: _jsx("span", { children: selectedView.label }) }));
        if (needShowUserGuide) {
            label = (_jsxs(CnBalloon, { trigger: label, visible: true, closable: false, className: 'mod-view-change-tip', align: 'br', type: 'primary', children: [_jsx("span", { className: 'tip-content', children: $i18n.get({
                            id: 'queryHasChangedTips',
                            dm: '您的查询条件发生变化，可点此进行保存',
                        }) }), _jsx(CnButton, { className: 'cn-next-align-right', onClick: () => {
                            onHideUserGuide();
                            setVisible(true);
                        }, size: 'small', "data-hottag": `${hottagPrefix}.view.closeUserGuide`, "data-hottag-name": '\u5173\u95ED\u89C6\u56FE\u65B0\u624B\u5F15\u5BFC', "data-hottag-ext-params": JSON.stringify({
                            sampling: 1,
                        }), children: $i18n.get({
                            id: 'IKnow',
                            dm: '我知道了',
                        }) })] }));
        }
    }
    const handleAddViewBtnClick = useMemoizedFn(async () => {
        const submit = (data) => {
            const { name, isDefault, ...others } = data || {};
            const newHabitData = {
                ...cacheHabitData,
            };
            const newView = {
                id: `${name}_${Date.now()}`,
                ...data,
                ...genNewViewDetail(),
            };
            const matchExistView = newHabitData.views?.find((v) => v.name === newView.name);
            // 同名覆盖即可
            if (matchExistView) {
                if (isDefault) {
                    newHabitData.defaultViewId = matchExistView.id;
                }
                matchExistView.filter = newView.filter;
                matchExistView.queryItems = newView.queryItems;
                newView.id = matchExistView.id;
            }
            else {
                if (isDefault) {
                    newHabitData.defaultViewId = newView.id;
                }
                newHabitData.views = (newHabitData.views || []).concat(newView);
            }
            return new Promise((resolve, reject) => {
                onHabitDataChange(newHabitData, (res = {}) => {
                    if (res.success) {
                        setTimeout(() => {
                            onChange(newView.id);
                        }, 0);
                        CnMessage.success($i18n.get({
                            id: 'QueryCriteriaSavedSuccessfully',
                            dm: '查询条件保存成功',
                        }));
                        resolve(true);
                    }
                    else {
                        if (!res.isCancel) {
                            CnMessage.error(res?.error?.message ||
                                $i18n.get({
                                    id: 'FailedToSaveQueryCriteria',
                                    dm: '查询条件保存失败',
                                }));
                        }
                        reject();
                    }
                }, {
                    action: 'add',
                    value: {
                        defaultViewId: newHabitData.defaultViewId,
                        name: newView.name,
                        isDefault,
                        ...others,
                    },
                });
            });
        };
        // 开启的编辑模式只对用户模版生效
        const currentSelectTemplate = viewList[1]?.children.find((view) => view?.id === viewId || view?.name === viewId);
        const { name: currentName = '', id = '' } = currentSelectTemplate || {};
        const editProperties = {
            isUpdateCurrentTemplate: {
                title: $i18n.get({
                    id: 'UpdateCurrentQueryConditionTempl_370013557',
                    dm: '是否更新当前查询条件模板',
                }),
                required: true,
                'x-component': 'CnRadioGroup',
                'x-decorator': 'CnFormItem',
                default: true,
                enum: [
                    {
                        label: $i18n.get({
                            id: 'Yes',
                            dm: '是',
                        }),
                        value: true,
                    },
                    {
                        label: $i18n.get({
                            id: 'No',
                            dm: '否',
                        }),
                        value: false,
                    },
                ],
                'x-reactions': [
                    {
                        target: 'name',
                        when: '{{$self.value}}',
                        fulfill: {
                            state: {
                                disabled: true,
                                value: currentName,
                            },
                        },
                        otherwise: {
                            state: {
                                disabled: false,
                                value: '',
                            },
                        },
                    },
                    {
                        target: 'isDefault',
                        when: '{{$self.value}}',
                        fulfill: {
                            state: {
                                // 编辑模版时由于当前没有取消默认模版后的逻辑，所以不允许默认查询置否
                                disabled: id === cacheHabitData.defaultViewId,
                                value: id === cacheHabitData.defaultViewId,
                            },
                        },
                        otherwise: {
                            state: {
                                disabled: false,
                                value: false,
                            },
                        },
                    },
                ],
            },
        };
        const properties = {
            name: {
                title: $i18n.get({
                    id: 'MyQueryConditionName',
                    dm: '我的查询条件名称',
                }),
                required: true,
                'x-component': 'CnInput',
                'x-decorator': 'CnFormItem',
                'x-decorator-props': {
                    extra: $i18n.get({
                        id: 'viewNameLengthTips',
                        dm: '命名在{viewNameLengthLimit}个字以内，如命名重复则覆盖之前的方案',
                    }, {
                        viewNameLengthLimit,
                    }),
                    requiredMessage: $i18n.get({
                        id: 'PleaseFillInTheQueryCriteria_662786607',
                        dm: '请填写查询条件名称',
                    }),
                },
                'x-component-props': {
                    trim: true,
                },
                'x-validator': (name) => {
                    if (name?.length > viewNameLengthLimit) {
                        return {
                            type: 'error',
                            message: $i18n.get({
                                id: 'TheQueryConditionNameCanBe_1829857448',
                                dm: '查询条件名称最多{viewNameLengthLimit}个字',
                            }, { viewNameLengthLimit }),
                        };
                    }
                    if (defaultViews.some((item) => item.name === name)) {
                        return {
                            type: 'error',
                            message: $i18n.get({
                                id: 'TheQueryConditionNameCannotBe_1869820625',
                                dm: '查询条件名称不能与预置查询条件重复',
                            }),
                        };
                    }
                    if (Array.isArray(cacheHabitData.views) &&
                        cacheHabitData.views.length >= customViewsLengthLimit &&
                        !cacheHabitData.views.some((item) => item.name === name)) {
                        return {
                            type: 'error',
                            message: $i18n.get({
                                id: 'MaximumNumberOfPrivateQueryConditions_639625451',
                                dm: '私人查询条件数量最多{customViewsLengthLimit}个',
                            }, { customViewsLengthLimit }),
                        };
                    }
                    return true;
                },
            },
            isDefault: {
                title: $i18n.get({
                    id: 'SetAsDefaultQueryCriteria',
                    dm: '是否设为默认查询条件',
                }),
                default: isOpenViewUpdate ? id === cacheHabitData.defaultViewId : false,
                'x-component': 'CnRadioGroup',
                'x-decorator': 'CnFormItem',
                'x-decorator-props': {
                    tip: $i18n.get({
                        id: 'NextTimeYouEnterTheCurrent_1217973892',
                        dm: '下次进入默认使用当前查询条件',
                    }),
                },
                'x-component-props': {
                    dataSource: [
                        {
                            label: $i18n.get({
                                id: 'Yes',
                                dm: '是',
                            }),
                            value: true,
                        },
                        {
                            label: $i18n.get({
                                id: 'No',
                                dm: '否',
                            }),
                            value: false,
                        },
                    ],
                },
            },
            ...extendSaveViewFormSchema,
        };
        cnQuickDialogForm($i18n.get({ id: 'SaveQueryCriteria', dm: '保存查询条件' }), {
            type: 'object',
            properties: isOpenViewUpdate && currentSelectTemplate
                ? { ...editProperties, ...properties }
                : properties,
        }, submit).open();
    });
    React.useEffect(() => {
        event.on('cnOneSearchAddCondition', handleAddViewBtnClick);
        return () => {
            event.off('cnOneSearchAddCondition', handleAddViewBtnClick);
        };
    }, [handleAddViewBtnClick]);
    return (_jsx(CnMenuButton, { className: 'mod-view-selector', label: label, text: true, size: 'medium', menuProps: {
            header: (_jsx("div", { className: 'mod-view-selector-header', children: !hideHabitSaveBtn ? (_jsxs(CnButton, { type: 'secondary', size: 'small', text: true, onClick: handleAddViewBtnClick, "data-hottag": `${hottagPrefix}.view.save`, "data-hottag-name": '\u4FDD\u5B58\u65B0\u7684\u89C6\u56FE', "data-hottag-ext-params": JSON.stringify({
                        sampling: 1,
                    }), children: [_jsx(CnIcon, { type: 'add', size: 'small', className: 'add-icon' }), $i18n.get({ id: 'SaveQueryCriteria', dm: '保存查询条件' })] })) : null })),
        }, popupClassName: 'one-search-mod-view-selector-popup', visible: visible, onVisibleChange: setVisible, disabled: disabled, children: viewList.map((groupItem) => {
            if (!Array.isArray(groupItem.children) ||
                groupItem.children.length === 0) {
                return null;
            }
            return (_jsx(CnMenuButtonGroup, { label: groupItem.label, children: groupItem.children.map((viewItem) => {
                    return renderViewItem(viewItem);
                }) }, groupItem.label));
        }) }));
}
ViewSelector.displayName = 'OneSearch.ViewSelector';
export default ViewSelector;
